import "./CustomToast.css";
import { IconButton, Snackbar, SnackbarOrigin, VariantProp } from "@mui/joy";
import { CloseRounded } from "@mui/icons-material";
export type ColorNotificacion =
  | "danger"
  | "success"
  | "warning"
  | "neutral"
  | "primary";

export interface NotificationProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  label?: string;
  color?: "danger" | "success" | "warning" | "neutral" | "primary";
  variant?: VariantProp;
  position?: SnackbarOrigin;
  duration?: number; //? in miliseconds
}
export const CustomToast: React.FC<NotificationProps> = ({
  open,
  setOpen,
  label,
  color,
  variant = "solid", // Cambio a solid para fondo sólido
  position = { vertical: "top", horizontal: "center" },
  duration = 5000,
}) => {
  // Función para obtener estilos específicos según el color
  const getColorStyles = (color: string) => {
    switch (color) {
      case "danger":
        return {
          backgroundColor: "#dc3545 !important",
          color: "white !important",
          border: "none",
        };
      case "success":
        return {
          backgroundColor: "#28a745 !important",
          color: "white !important",
          border: "none",
        };
      case "warning":
        return {
          backgroundColor: "#ffc107 !important",
          color: "black !important",
          border: "none",
        };
      default:
        return {};
    }
  };

  return (
    <Snackbar
      open={open}
      onClose={() => setOpen(false)}
      variant={variant}
      color={color}
      anchorOrigin={position}
      autoHideDuration={duration}
      sx={{
        fontWeight: "bold",
        borderRadius: "10px",
        ...getColorStyles(color || ""),
        "& .MuiSnackbar-root": {
          borderRadius: "10px",
          ...getColorStyles(color || ""),
        },
      }}
      endDecorator={
        <IconButton
          onClick={() => setOpen(false)}
          size="sm"
          variant={"plain"}
          sx={{
            color:
              color === "warning" ? "black !important" : "white !important",
          }}
        >
          <CloseRounded />
        </IconButton>
      }
    >
      {label}
    </Snackbar>
  );
};

export default CustomToast;
